<template>
  <main class="main cart-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">SHOPPING CART</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <section class="section page-body-section cart-section">
        <div class="circle"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="wrapper">
          <div class="desc empty-desc" v-if="!$parent.cartContents.length">
            {{ $t("Cart is empty!") }}
          </div>
          <div class="left" v-if="$parent.cartContents.length">
            <div class="product-list">
              <div
                class="item"
                v-for="(item, i) in $parent.cartContents"
                :key="i"
              >
                <div class="preview">
                  <img :src="imgDomain + item.item.img_url" class="img" />
                </div>
                <div class="text">
                  <div class="desc medium name">{{ item.item.title }}</div>
                  <div class="desc desc-28 price">
                    <b>{{ item.item.price }}</b>
                    <b class="currency">{{ $parent.currency }}</b>
                  </div>
                </div>
                <div class="count">
                  <div
                    class="count__item minus"
                    @click="$parent.removeOneFromCart(item, item.item_id)"
                  ></div>
                  <input
                    type="number"
                    value="1"
                    v-model="item.count"
                    step="1"
                  />
                  <div
                    class="count__item plus"
                    @click="$parent.addToCart(item.item, item.item_id)"
                  ></div>
                </div>

                <div
                  class="delete"
                  @click="$parent.removeFromCart(item.item, item.item_id)"
                >
                  <img src="./../images/bin.svg" class="img" />
                </div>
              </div>
            </div>
            <div class="delete-all" @click="$parent.emptyCart">
              <div class="desc">{{ $t("delete all") }}</div>
            </div>
          </div>
          <div class="right" v-if="$parent.cartContents.length">
            <div class="desc desc-32">{{ $t("TOTAL") }}:</div>
            <div class="desc desc-56">
              <b>{{ $parent.totalSum }}</b>
              <b class="currency">{{ $parent.currency }}</b>
            </div>
            <button @click="toOrder" class="button rounded small w-200">
              <span>{{ $t("Order") }}</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
export default {
  name: "Cart",
  props: [],
  components: {},
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    toOrder() {
      this.$router.push({ path: "/order" });
    },
  },
};
</script>
